import React from 'react'

export default function InsurerFaxSettingCells({
  value,
  onChange,
  disabled = false,
  saving = false,
  onSave,
  inputClassName = 'w-full rounded border px-2 py-1.5 disabled:bg-slate-50 disabled:text-slate-400',
  saveButtonClassName = 'rounded bg-brand-navy px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-50',
}) {
  const row = value || {}

  return (
    <>
      {[
        ['claimFaxNumber', '미분기 시·사고유형 없음'],
        ['faxRoutingDisease', '질병 청구 시'],
        ['faxRoutingInjury', '상해·재해·교통 등'],
      ].map(([field, placeholder]) => (
        <td key={field} className="px-3 py-3">
          <input
            className={inputClassName}
            placeholder={placeholder}
            value={row[field] || ''}
            onChange={(e) => onChange?.({ [field]: e.target.value })}
            disabled={disabled || saving}
          />
        </td>
      ))}
      <td className="px-3 py-3">
        <label className={`inline-flex items-center gap-2 ${disabled ? 'text-slate-400' : 'cursor-pointer'}`}>
          <input
            type="checkbox"
            checked={!!row.virtualFaxRequired}
            onChange={(e) => onChange?.({ virtualFaxRequired: e.target.checked })}
            disabled={disabled || saving}
          />
          <span className="text-slate-700">필수</span>
        </label>
      </td>
      <td className="px-3 py-3">
        <input
          className={inputClassName}
          placeholder="내부 메모"
          value={row.memo || ''}
          onChange={(e) => onChange?.({ memo: e.target.value })}
          disabled={disabled || saving}
        />
      </td>
      <td className="px-3 py-3">
        <button
          type="button"
          className={saveButtonClassName}
          disabled={disabled || saving}
          onClick={onSave}
        >
          {saving ? '저장…' : '저장'}
        </button>
      </td>
    </>
  )
}
